module.exports = __webpack_public_path__ + "img/londing.d45dba90.gif";